import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'

import { PATHS } from '@/config/router/routes'
import { hasPermission, useAccessControl } from '@/ducks/auth/auth.permissions'
import { selectIsAuthed } from '@/ducks/auth/auth.selectors'
import { PermissionRequirement } from '@/ducks/auth/auth.types'

interface ProtectedRouteProps {
  element: React.JSX.Element
  requiredPermission?: PermissionRequirement
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  element,
  requiredPermission
}) => {
  const isAuthenticated = useSelector(selectIsAuthed)
  const { isRbacEnabled, permissions, rolesLoaded } = useAccessControl()

  if (!isAuthenticated) {
    // @ts-ignore
    return <Redirect to={PATHS.LOGIN} />
  }

  if (!requiredPermission || !isRbacEnabled) {
    return element
  }

  if (!rolesLoaded) {
    return null
  }

  return hasPermission(permissions, requiredPermission, { isRbacEnabled }) ? (
    element
  ) : (
    // @ts-ignore
    <Redirect to={PATHS.ORDERS} />
  )
}

export default ProtectedRoute
